import { Store } from '@ngrx/store';
import { Injectable } from '@angular/core';
import { ValidateStoreInviteToken } from './+state/auth.actions';
import { ActivatedRouteSnapshot } from '@angular/router';
import { extractTokenFromUrl } from './token-helper';

@Injectable({
  providedIn: 'root',
})
export class InvitationGuard {
  constructor(private store: Store<any>) {}

  canActivate(route: ActivatedRouteSnapshot) {
    const rawToken = extractTokenFromUrl();
    if (rawToken) {
      this.store.dispatch(new ValidateStoreInviteToken(rawToken));
    }
    return true;
  }
}
